// Conteúdo editorial e institucional do site Leão de Fogo

export const CONTACT_INFO = {
  whatsappNumber: '5577999123040',
  whatsappDisplay: '+55 (77) 99912-3040',
  email: 'leaodefogo.icp@gmail.com',
};

export const LOGO_URL =
  'https://customer-assets.emergentagent.com/job_leao-fogo/artifacts/hx2uvdyg_APENAS%20LOGOMARCA.png';

export const MARQUEE_ITEMS = [
  'Extintores de Incêndio',
  'Mangueiras Industriais',
  'Projetos de Incêndio',
  'Cursos de Brigada',
  'SPDA & Alvará',
  'Sinalização Tática',
  'Iluminação de Emergência',
];

export const SHOWCASE_BANNERS = [
  {
    id: 1,
    kicker: 'Equipamentos',
    title: 'Equipamentos de qualidade superior',
    subtitle: 'Linha completa de produtos certificados',
    description: 'Extintores, detectores, iluminação de emergência e muito mais',
    image:
      'https://customer-assets.emergentagent.com/job_leao-fogo/artifacts/1vrncnyy_Capas%20WebExtintor.webp',
    buttonText: 'Ver Produtos',
    target: '#produtos',
  },
  {
    id: 2,
    kicker: 'Treinamentos',
    title: 'Treinamentos profissionais',
    subtitle: 'Capacitação completa para sua brigada',
    description: 'Cursos básico, intermediário, avançado e reciclagem com certificação',
    image:
      'https://images.unsplash.com/photo-1764239651625-c611fe706915?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHw0fHxmaXJlJTIwc2FmZXR5JTIwZGFyayUyMGJhY2tncm91bmQlMjBzcGFya3MlMjBpbmR1c3RyaWFsJTIwc21va2V8ZW58MHx8fHwxNzkyNjg5MjIzfDA&ixlib=rb-4.1.0&q=85',
    buttonText: 'Conhecer Cursos',
    target: '#servicos',
  },
  {
    id: 3,
    kicker: 'Projetos',
    title: 'Projetos especializados',
    subtitle: 'Soluções completas em engenharia de segurança',
    description: 'Projetos de incêndio, SPDA, arquitetônico e renovação de alvará',
    image:
      'https://images.pexels.com/photos/3678228/pexels-photo-3678228.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    buttonText: 'Solicitar Projeto',
    target: '#servicos',
  },
  {
    id: 4,
    kicker: 'Desde 2017',
    title: 'Excelência desde 2017',
    subtitle: 'Mais de 7 anos de experiência no mercado',
    description: 'Produtos certificados, serviços qualificados e atendimento diferenciado',
    image:
      'https://customer-assets.emergentagent.com/job_leao-fogo/artifacts/8o19q8bk_Capas%20WebMangueiras.webp',
    buttonText: 'Fale Conosco',
    target: '#contato-form',
  },
];

export const PROJECT_TYPES = [
  {
    id: 1,
    name: 'Projeto Arquitetônico',
    description:
      'Desenvolvimento de projetos arquitetônicos completos com foco em segurança contra incêndio.',
    icon: 'Building',
  },
  {
    id: 2,
    name: 'Projeto de Incêndio',
    description:
      'Projetos técnicos de sistemas de prevenção e combate a incêndio conforme normas vigentes.',
    icon: 'Flame',
  },
  {
    id: 3,
    name: 'Renovação de Alvará',
    description:
      'Assessoria completa para renovação de alvará de funcionamento junto ao Corpo de Bombeiros.',
    icon: 'FileCheck',
  },
  {
    id: 4,
    name: 'SPDA',
    description: 'Projeto de Sistema de Proteção contra Descargas Atmosféricas (Para-raios).',
    icon: 'Zap',
  },
];

export const COURSES = [
  {
    id: 1,
    level: 'Básico',
    duration: '8 horas',
    description:
      'Introdução aos conceitos fundamentais de combate a incêndio, uso de extintores e procedimentos de evacuação.',
    topics: ['Teoria do fogo', 'Classes de incêndio', 'Uso de extintores', 'Rotas de fuga'],
  },
  {
    id: 2,
    level: 'Intermediário',
    duration: '20 horas',
    description:
      'Aprofundamento em técnicas de combate, primeiros socorros e coordenação de emergências.',
    topics: [
      'Técnicas avançadas',
      'Primeiros socorros',
      'Coordenação de evacuação',
      'Prevenção de riscos',
    ],
  },
  {
    id: 3,
    level: 'Avançado',
    duration: '30 horas',
    description:
      'Formação completa para líderes de brigada com simulações práticas e gestão de crises.',
    topics: [
      'Liderança de brigada',
      'Gestão de crises',
      'Simulações práticas',
      'Planos de emergência',
    ],
  },
  {
    id: 4,
    level: 'Reciclagem',
    duration: '8 horas',
    description: 'Atualização e revisão de conhecimentos para brigadistas já certificados.',
    topics: [
      'Revisão de conceitos',
      'Novas normas',
      'Prática de extintores',
      'Atualização de procedimentos',
    ],
  },
];

export const CERTIFICATION_INFO = {
  validity: '12 meses',
  requirements: 'Frequência mínima de 75% e aprovação na avaliação prática',
  benefits: [
    'Certificado reconhecido pelo Corpo de Bombeiros',
    'Capacitação profissional qualificada',
    'Atualização conforme normas vigentes',
    'Material didático incluso',
  ],
};
